import React, { useState } from "react";
import {
  ContentsHeader,
  PrimaryButton,
  SecondaryButton,
  KebabMenu,
} from "@graffer-inc/console-design-kit";
import { ArchiveDialog } from "./archiveDialog";

interface EditContentsHeaderProps {
  rulesetName: string;
  onSave: () => void;
  onCancel: () => void;
  onArchive?: () => Promise<void>;
}

export const EditContentsHeader: React.FC<EditContentsHeaderProps> = ({
  rulesetName,
  onSave,
  onCancel,
  onArchive,
}) => {
  const [isArchiveDialogOpen, setIsArchiveDialogOpen] = useState(false);

  const showArchiveDialog = () => {
    setIsArchiveDialogOpen(true);
  };

  const hideArchiveDialog = () => {
    setIsArchiveDialogOpen(false);
  };

  const handleArchiveConfirm = async () => {
    if (onArchive) {
      await onArchive();
    }
    hideArchiveDialog();
  };

  const kebabMenuItems = [
    {
      title: "アーカイブ",
      menuItems: [
        {
          text: "設定をアーカイブする",
          anchor: ({ children }: { children: React.ReactNode }) => (
            <button type="button" onClick={showArchiveDialog}>
              {children}
            </button>
          ),
        },
      ],
    },
  ];

  return (
    <>
      <ContentsHeader
        title="申請振り分け設定編集"
        border={false}
        buttons={[
          [
            <div key="cancelButton" className="level-item">
              <SecondaryButton text="キャンセル" onClick={onCancel} />
            </div>,
            <div key="saveButton" className="level-item">
              <PrimaryButton text="更新" onClick={onSave} />
            </div>,
            <div key="kebabMenu" className="level-item">
              <KebabMenu items={kebabMenuItems} />
            </div>,
          ],
        ]}
      />
      {isArchiveDialogOpen && (
        <ArchiveDialog
          isOpen={isArchiveDialogOpen}
          onConfirm={handleArchiveConfirm}
          onCancel={hideArchiveDialog}
          rulesetName={rulesetName}
        />
      )}
    </>
  );
};
